
import { Injectable } from "@angular/core";
import { EtatLexi, EtatRevatua } from "./revatua-etat";
import { ConnaissementStatut, StatutRevatua } from "@lexi-clients/lexi";
import { PopupAction } from "../connaissement-list/connaissement-list.component";
import { stat } from "fs";

@Injectable()
export class ReferencesConnaissementService {

  getEtatLexi() : EtatLexi[]{
    const etats = [
      {id : ConnaissementStatut.annule, libelle: 'Annulé', color: 'red', icon: 'dx-icon-revert', decoration:'line-through', fontStyle:'', fontWeight: 400},
      {id : ConnaissementStatut.none, libelle: 'Aucun', color: '', icon: 'dx-icon-file', decoration:'', fontStyle:'', fontWeight: 400},
      {id : ConnaissementStatut.saisie, libelle: 'Saisie', color: '', icon: 'dx-icon-file', decoration:'', fontStyle:'', fontWeight: 400},
      {id : ConnaissementStatut.valide, libelle: 'Validé', color: 'green', icon: 'dx-icon-check', decoration:'', fontStyle:'', fontWeight: 400},
    ]
    return etats.sort((a, b) => a.libelle.localeCompare(b.libelle));
  }
  getEtatRevatua(): EtatRevatua[] {
    const etats = [
      { id: StatutRevatua.aucun, libelle: 'Aucun', color: '', icon: 'dx-icon-file', decoration:'', fontStyle:'', fontWeight: 400},
      { id: StatutRevatua.saisie, libelle: 'Saisie', color: '', icon: 'dx-icon-file', decoration:'', fontStyle:'', fontWeight: 400},
      { id: StatutRevatua.modification, libelle: 'Modification', color: '', icon: 'dx-icon-edit', decoration:'', fontStyle:'', fontWeight: 400},
      { id: StatutRevatua.demande, libelle: 'Demande', color: 'blue', icon: 'dx-icon-help blue', decoration:'', fontStyle:'', fontWeight: 400},
      { id: StatutRevatua.transfert, libelle: 'Transfert', color: 'blue', icon: 'dx-icon-tags', decoration:'', fontStyle:'', fontWeight: 400},
      { id: StatutRevatua.officialisESousReserve, libelle: 'Officialisé sous réserve', color: 'blue', icon: 'dx-icon-info', decoration:'', fontStyle:'', fontWeight: 400},
      { id: StatutRevatua.officialise, libelle: 'Officialisé', color: 'green', icon: 'dx-icon-check', decoration:'', fontStyle:'', fontWeight: 400},
      { id: StatutRevatua.brouillon, libelle: 'Brouillon', color: '', icon: 'dx-icon-file', decoration:'', fontStyle:'', fontWeight: 400},
      { id: StatutRevatua.embarque, libelle: 'Embarqué', color: 'green', icon: 'dx-icon-key', decoration:'', fontStyle:'', fontWeight: 450},
      { id: StatutRevatua.priSEnCharge, libelle: 'Pris en charge', color: 'green', icon: 'dx-icon-pin', decoration:'', fontStyle:'', fontWeight: 400},
      { id: StatutRevatua.annule, libelle: 'Annulé', color: 'red', icon: 'dx-icon-revert', decoration:'line-through', fontStyle:'', fontWeight: 400},
      { id: StatutRevatua.demandERefusee, libelle: 'Demande refusée', color: 'red', icon: 'dx-icon-remove', decoration:'', fontStyle:'', fontWeight: 400},
      { id: StatutRevatua.embarquemenTRefuse, libelle: 'Embarquement réfusé', color: 'red', icon: 'dx-icon-remove', decoration:'', fontStyle:'', fontWeight: 400},
    ];
    
    return etats.sort((a, b) => a.libelle.localeCompare(b.libelle));
  }

  getEtatRevatuaEnumValue(statutRevatua : StatutRevatua) : number{
    switch(statutRevatua){
      case StatutRevatua.saisie : return 0;
      case StatutRevatua.officialise : return 1;
      case StatutRevatua.embarque : return 2;
      case StatutRevatua.embarquemenTRefuse : return 3;
      case StatutRevatua.annule : return 4;
      case StatutRevatua.modification : return 5;
      case StatutRevatua.transfert : return 6;
      case StatutRevatua.brouillon : return 7;
      case StatutRevatua.demande : return 8;
      case StatutRevatua.demandERefusee : return 9;
      case StatutRevatua.officialisESousReserve : return 10;
      case StatutRevatua.priSEnCharge : return 11;
      case StatutRevatua.aucun : return 12;
    }
  }

  getEtatLexiEnumValue(statutLexi : ConnaissementStatut) : number{
    switch(statutLexi){
      case ConnaissementStatut.none : return 0;
      case ConnaissementStatut.saisie : return 1;
      case ConnaissementStatut.valide : return 2;
      case ConnaissementStatut.annule : return 3;
    }
  }

  getPopUpSize(smallWidth: number, smallHeight: number, popupAction: PopupAction) {
    if (window.screen.width > 1536) {
      popupAction.width = 1200;
      popupAction.height = 800;
    } else {
      popupAction.width = smallWidth;
      popupAction.height = smallHeight;
    }
  }
}

export enum TypePopupVisibleEnum {
  AucunAffichage,
  TraitementEnvoiConnaissement,
  AffectationVoyageRevatua,
  TransfererConnaissement,
  AfficherDetailConnaissement,
  UpdateConnaissementBackOffice,
  SelectionPrestationComplementaire,
  ConfirmerFacturationConnaissement,
  FacturerConnaissement
}